module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container remove-margins"
  }, [(_vm.petsListComp) ? _c('div', [(_vm.petsListComp.length < 1) ? _c('div', [_c('h4', [_vm._v("No pets added yet, please Add new pet")])]) : _vm._e(), _vm._v(" "), (_vm.petsListComp && _vm.petsListComp.length > 0) ? _c('div', _vm._l((_vm.petsListComp), function(pet, index) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-5 col-lg-4 col-xs-12 remove-margins"
    }, [_c('PetProfileCard', {
      key: pet.PetId,
      attrs: {
        "petId": pet.PetId
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.petsListComp && _vm.petsListComp.length > 0) ? _c('div', {
    staticClass: "container remove-margins"
  }, [_c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn-success btn-lg",
    attrs: {
      "href": "https://www.dupaws.com/findsitters"
    }
  }, [_vm._v("Find and Book Pet Sitters")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60f75619!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetRegistration/MyPets.vue
// module id = 635
// module chunks = 2